import React from 'react';
import {Card, Block, ModalComponentProps, Dialog, DialogBody, DialogFooter, Button, VF, makeValidate, Space, Col, Row, Yup} from '@mc/ui-v4';
import {Form, FormRenderProps} from 'react-final-form';
import {rffFormSubmit, WaitForQueryData} from '@mc/react-app-v4';
import {useQuery} from 'react-query';
import {GmlExportApi, VrstvaSimpleVO} from '../../api';
import {useAppConfig} from '@mc/react-app-base';

type DownloadDataProps = {
    layerId?: number;
};

export const DownloadLayerDataModal: React.FC<ModalComponentProps> = ({onClose}) => {
    const validateSchema = Yup.object().shape({
        layerId: Yup.string().required('Vyberte vrstvu pro export'),
    });
    const validation = makeValidate(validateSchema);
    const vrstvyPracovnikaQuery = useQuery<VrstvaSimpleVO[]>(['CACHE_KEY_GML_VRSTVY_PRACOVNIKA'], async () => (await GmlExportApi.getVrstvyPracovnika()).data);
    const app = useAppConfig();

    return (
        <Form<DownloadDataProps>
            onSubmit={async data => {
                return await rffFormSubmit(async () => {
                    const downloadUrl = (await GmlExportApi.exportAllObjektVrstva(data.layerId)).data;
                    window.open(`${window.origin}${app.serverContextPath}${downloadUrl}`, '_blank');
                    onClose();
                });
            }}
            validate={async data => {
                return await validation(data);
            }}
        >
            {({submitting, handleSubmit}: FormRenderProps<DownloadDataProps>) => {
                return (
                    <Dialog size="sm" onClose={onClose} title={`Stáhnout data vrstvy dle IPR`}>
                        <DialogBody>
                            <Space vertical>
                                <Card mode={'edit'}>
                                    <Block>
                                        <Row>
                                            <Col>
                                                <WaitForQueryData queries={[vrstvyPracovnikaQuery]}>
                                                    {() => {
                                                        const vrstvy = vrstvyPracovnikaQuery.data || [];

                                                        return (
                                                            <VF.SelectBox
                                                                name={'layerId'}
                                                                required
                                                                label={'Vrstva'}
                                                                getItemName={(item: VrstvaSimpleVO) => item && `${item.label} (${item.kod})`}
                                                                items={vrstvy}
                                                                disabled={submitting}
                                                                useIdAsValue
                                                            />
                                                        );
                                                    }}
                                                </WaitForQueryData>
                                            </Col>
                                        </Row>
                                    </Block>
                                </Card>
                            </Space>
                        </DialogBody>
                        <DialogFooter>
                            <Button style="default" onClick={onClose} disabled={submitting}>
                                Zrušit
                            </Button>
                            <Button style="primary" onClick={handleSubmit} disabled={submitting}>
                                Exportovat
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
